import IztTabs from './src/izt-tabs'

IztTabs.install = Vue => {
  Vue.component(IztTabs.name, IztTabs)
}

export default IztTabs